import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactHtmlParser from 'react-html-parser';

import { URL_IMG } from '../../../configs/urlConfigs';
import { MSG_REQUIRED, MSG_NOT_FOUND, MSG_SKILL_ADD_SUCCESS, MSG_SKILL_ADD_ERROR, MSG_SKILL_UPDATE_SUCCESS, MSG_SKILL_DELETE_SUCCESS, MSG_SKILL_DUP_ERROR } from '../../../configs/msgConfigs';
import { LBL_APP_NAME, LBL_SETTINGS, LBL_SKILLS, LBL_BTN_ADDNEW, LBL_SHOW_DATE_RANGE, LBL_ACTIVE, LBL_CONFIRM_DELETE, LBL_SKILL, LBL_SUB_SECTOR, LBL_SUB_SECTORS, LBL_CERTIFICATEMANDATORY, LBL_CERTIFICATE_NAME, LBL_BACK_TO_SETTINGS, LBL_ICON_FONTAWESOME_CLASS, LBL_ACTIONS, LBL_EDIT, LBL_DELETE, LBL_FONTAWESOME_ICON_CLASS, LBL_FONTAWESOME_ICON_URL, LBL_FONTAWESOME_ICON_GUIDELINE1, LBL_FONTAWESOME_ICON_GUIDELINE2, LBL_FONTAWESOME_ICON_GUIDELINE3, LBL_FONTAWESOME_ICON_GUIDELINE4, LBL_FONTAWESOME_ICON_GUIDELINE5, LBL_FONTAWESOME_ICON_GUIDELINE6 } from '../../../configs/labelConfigs';
import { ROUTE_REFRESH, PAGING_END_INDEX, PAGENUMROWS_SUPER, ROUTE_SA_SETTINGS } from '../../../configs/staticConfigs';
import * as types from '../../../actions';

import Toast from '../../commons/helpers/toast';
import Paginator from '../../commons/helpers/paginator';
import ModalWindow from '../../commons/helpers/modalWindow';
import CustomMultiSelect from '../../commons/helpers/customMultiSelect';

import { formValid } from '../../../utils/validation';

import { skillListAction, skillAddAction, skillEditAction, skillUpdateAction, skillDeleteAction, subSectorListAction } from '../../../actions/settings/superadmin/skillActions';
import { clearAction } from '../../../actions/commonActions';

class SkillsComponent extends Component {

    constructor(props) {
        super()

        this.state = {
            activePage: 1,
            startIndex: 0,
            endIndex: PAGING_END_INDEX,
            perPageCount: PAGENUMROWS_SUPER,
            activeRowId: 0,
            formErrors: {
                skillName: "",
                certificateName: "",
                subsectors_error: ""
            },
            skillData: {
                skillId: '',
                skillName: null,
                iconFontawesomeClass: '', 
                certificateName: null,
                certificateRequired: false,
                showDateRange: false,
                isActive: true,
                sub_sectors: [],
            },
            skillNameSelected: '',
            sortField: 'skill_name',
            sortOrder: '',
            toastMessage: '',
            toastFlag: false,
            toastSuccess: true,
            subsectors: [],
            subsectorMultiSelList: [],
            subSectorsLoaded: false,
        }

        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.onSort = this.onSort.bind(this);

        this.modalAdd = React.createRef(); 
        this.modalDelete = React.createRef();

    }

    openModal() {
        let formErrors = this.state.formErrors;
        formErrors.skillName = '';
        formErrors.certificateName = '';
        this.setState({ formErrors });
        this.modalAdd.current.handleOpenModal();
    }

    onModalFormReset = () => {
        let arrSS = this.state.subsectorMultiSelList;
        let arrNew = [];
        arrSS.forEach(ssObj => {
            arrNew.push({ value: ssObj.value, label: ssObj.label });
        });

        this.setState({
            skillData: {
                skillId: '',
                skillName: null,
                iconFontawesomeClass: '', 
                certificateName: null,
                certificateRequired: false,
                isActive: true,
                sub_sectors: [],
            }, subsectorMultiSelList: arrNew, subsectors: []
        });
    }

    onHandleChange = (event) => {

        const { name } = event.target;
        let trimmedValue = '';

        const value = event.target.type === "checkbox" ? event.target.checked : event.target.value;

        if (event.target.type === "text") {
            trimmedValue = value.trim();
        }

        let formErrors = this.state.formErrors;
        let skillData = this.state.skillData;
        switch (name) {
            case 'skillName':
                formErrors.skillName = trimmedValue.length <= 0 ? MSG_REQUIRED : ""; 
                break;
            case 'certificateName':
                formErrors.certificateName =
                    trimmedValue.length <= 0 && skillData.certificateRequired
                        ? MSG_REQUIRED
                        : ""
                break;
            case 'certificateRequired':
                formErrors.certificateName = ""
                break;
            default:
                break;
        }

        skillData[name] = value;
        if (name === 'certificateRequired' && value === false) {
            skillData['showDateRange'] = false;
        }

        this.setState({ formErrors, skillData });

    }

    onShowActionButtons = (event, rowId) => {

        let dropdown = document.getElementById('dropdown-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-' + rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');

        if (this.state.activeRowId === 0) {
            this.setState({ activeRowId: rowId });
            document.getElementById('img-action-' + rowId).focus();
        }
        else if (this.state.activeRowId === rowId) {
            this.setState({ activeRowId: 0 });
        }
        else if (this.state.activeRowId !== rowId) {
            dropdown = document.getElementById('dropdown-' + this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-' + this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({ activeRowId: rowId });
            document.getElementById('img-action-' + rowId).focus();
        }

    }

    onHideActionButtons = (event, rowId) => {
        let dropdown = document.getElementById('dropdown-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-' + rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({ activeRowId: 0 });
    }

    onSaveFormData = (id) => {
        const { skillData } = this.state;
        if (formValid(this.state)) {
            if (this.state.subsectors.length === 0) {
                let formErrors = this.state.formErrors;
                formErrors.subsectors_error = MSG_REQUIRED;
                this.setState({ formErrors });
            }
            else {
                let skillsData = {
                    skill_name: skillData.skillName,
                    icon_fontawesome_class: skillData.iconFontawesomeClass, 
                    certificate_name: skillData.certificateName,
                    certificate_required: skillData.certificateRequired,
                    date_range: skillData.showDateRange,
                    is_active: skillData.isActive,
                    sub_sectors: this.state.subsectors
                }
                if (id) {
                    skillsData['id'] = id;
                    this.props.skillUpdateAction(skillsData);
                } else {
                    this.props.skillAddAction(skillsData);
                }
            }
        } else {
            let formErrors = this.state.formErrors;
            if (skillData.skillName == null) {
                formErrors.skillName = MSG_REQUIRED;
            }
            if (this.state.subsectors.length === 0) {
                formErrors.subsectors_error = MSG_REQUIRED;
            }
            if (skillData.certificateName === null && skillData.certificateRequired) {
                formErrors.certificateName = MSG_REQUIRED;
            }

            this.setState({ formErrors });
        }

    }

    editBtnClick = (rowId) => {
        let formErrors = this.state.formErrors;
        formErrors.subsectors_error = '';
        formErrors.skillName = '';
        formErrors.certificateName = '';
        this.setState(formErrors);
        this.modalAdd.current.handleOpenModal(); 
        this.props.skillEditAction(rowId);
    }

    deleteBtnClick = (rowId, name) => {
        this.setState({
            skillData: {
                skillId: rowId,
            },
            skillNameSelected: name
        });
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () => {
        let skillId = this.state.skillData.skillId;
        this.props.skillDeleteAction(skillId);
        this.modalDelete.current.handleModelClose();
    }

    onSort = (event, sortKey) => {
        let sOrder = '';
        if (this.state.sortField === sortKey) {
            sOrder = (this.state.sortOrder === '-') ? '' : '-';
            this.props.skillListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: sOrder + this.state.sortField });
            this.setState({ sortOrder: sOrder });
        } else {
            this.setState({ sortField: sortKey });
            this.props.skillListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + sortKey });
        }
    }

    onPagePrevious = (e) => {
        const {
            startIndex, endIndex
        } = this.state

        let previousPage = startIndex + 1 - PAGING_END_INDEX
        this.props.skillListAction({ pageSize: this.state.perPageCount, page: previousPage, column: this.state.sortOrder + this.state.sortField });

        if (startIndex === 0) {
            this.setState({
                activePage: previousPage,
                startIndex: startIndex,
                endIndex: endIndex
            });
        } else {
            this.setState({
                activePage: previousPage,
                startIndex: startIndex - PAGING_END_INDEX,
                endIndex: endIndex - PAGING_END_INDEX
            });
        }

    }

    onPageUp = (e) => {

        this.props.skillListAction({ pageSize: this.state.perPageCount, page: e.target.id, column: this.state.sortOrder + this.state.sortField });


        this.setState({
            activePage: Number(e.target.id)
        });
    }

    onPageNext = (e) => {
        const {
            startIndex, endIndex
        } = this.state

        const {
            totalPage
        } = this.props

        let nextPage = startIndex + 1 + PAGING_END_INDEX;
        this.props.skillListAction({ pageSize: this.state.perPageCount, page: nextPage, column: this.state.sortOrder + this.state.sortField });
        if (endIndex === totalPage || totalPage <= PAGING_END_INDEX) {
            this.setState({
                activePage: nextPage,
                startIndex: startIndex,
                endIndex: endIndex
            });
        } else {
            this.setState({
                activePage: nextPage,
                startIndex: startIndex + PAGING_END_INDEX,
                endIndex: endIndex + PAGING_END_INDEX
            });
        }

    }

    onCloseToast = () => {
        this.setState({ toastFlag: false, toastMessage: '' });
    }

    setToasterState(isEnabled, message, isSucces) {
        this.setState({ toastFlag: isEnabled, toastMessage: message, toastSuccess: isSucces });
        setTimeout(() => {
            this.onCloseToast();
        }, 3000);
    }

    handleChangeMultiSel = (selectdOptions) => {
        let newDataArray = [];
        selectdOptions.forEach((item) => {
            newDataArray.push(item.value);
        });

        let formErrors = this.state.formErrors;
        formErrors.subsectors_error = newDataArray.length === 0 ? MSG_REQUIRED : '';
        this.setState({ subsectors: newDataArray, formErrors });
    }

    getSubSectorNames = (arrSIds) => {
        //{"id": 148, "sector": "Hospitality", "name": "Caterers"}
        let subSectorsString = '';
        let sepVar = '';
        let sObj = {}
        if (arrSIds.length) {
            arrSIds.map((sId) => {
                sObj = this.state.subsectorMultiSelList.find(item => item.value == sId);
                if (sObj) {
                    subSectorsString += sepVar + sObj.label;
                    sepVar = ' <br> ';
                }
            });
            return subSectorsString;
        }
        else {
            return subSectorsString;
        }

    }


    setStateUpdate(skill, status, activity, numRows, totalPage, errorData) {
        let formErrors = this.state.formErrors;
        if (activity === types.SUPERADMIN_SKILL_ADD_SUCCESS) {
            this.modalAdd.current.handleModelClose();
            this.props.skillListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + this.state.sortField });
            this.setToasterState(true, MSG_SKILL_ADD_SUCCESS, true);
        } else if (activity === types.SUPERADMIN_SKILL_ADD_ERROR) {
            if (status === 400) {
                if (errorData.hasOwnProperty('name')) {
                    formErrors.skillName = errorData.name[0];
                } else {
                    this.modalAdd.current.handleModelClose();
                    this.setToasterState(true, MSG_SKILL_ADD_ERROR, false);
                }
                this.setState(formErrors);
            } else {
                if(errorData?.message && errorData.message=="already_exist") {
                    formErrors.skillName = MSG_SKILL_DUP_ERROR;
                    this.setState(formErrors);
                }
                else if (errorData.hasOwnProperty('message')) { 
                    this.modalAdd.current.handleModelClose();
                    this.setToasterState(true, errorData.message, false);
                } else {
                    this.modalAdd.current.handleModelClose();
                    // this.setToasterState(true, JSON.stringify(errorData), false);
                    console.log('SUPERADMIN_SKILL_ADD_ERROR: ', errorData);
                    this.setToasterState(true, MSG_SKILL_ADD_ERROR, false);
                }
            }
        } else if (activity === types.SUPERADMIN_SKILL_UPDATE_SUCCESS) {
            this.modalAdd.current.handleModelClose();
            this.setToasterState(true, MSG_SKILL_UPDATE_SUCCESS, true);
            this.props.skillListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + this.state.sortField });
        } else if (activity === types.SUPERADMIN_SKILL_UPDATE_ERROR) {
            if(errorData?.message && errorData.message=="already_exist") {
                formErrors.skillName = MSG_SKILL_DUP_ERROR;
                this.setState(formErrors);
            } else if (status === 400) {
                if (errorData.hasOwnProperty('name')) {
                    formErrors.skillName = errorData.name[0];
                    this.setState(formErrors);
                } else {
                    this.modalAdd.current.handleModelClose();
                    this.setToasterState(true, JSON.stringify(errorData), false);
                }
            } 
            else {
                this.modalAdd.current.handleModelClose();
                if (errorData.hasOwnProperty('message')) {
                    this.setToasterState(true, errorData.message, false);
                } else {
                    this.setToasterState(true, JSON.stringify(errorData), false);
                }
            }
        } else if (activity === types.SUPERADMIN_SKILL_EDIT_SUCCESS) {
            let arrSS = this.state.subsectorMultiSelList;
            let arrNew = [];
            arrSS.forEach(ssObj => {
                if (skill.sub_sectors && skill.sub_sectors.find(item => item == ssObj.value)) {
                    arrNew.push({ value: ssObj.value, label: ssObj.label, inputVal: ssObj.value });
                }
                else {
                    arrNew.push({ value: ssObj.value, label: ssObj.label });
                }
            });
            this.setState({
                skillData: {
                    skillId: skill.id,
                    skillName: skill.name,
                    iconFontawesomeClass: skill.iconFontawesomeClass, 
                    certificateName: skill.certificateName,
                    certificateRequired: skill.certificateRequired,
                    showDateRange: skill.showDateRange,
                    isActive: skill.isActive,
                    sub_sectors: skill.sub_sectors
                }, subsectorMultiSelList: arrNew, subsectors: skill.sub_sectors
            }, () => {
                if (document.getElementById('skillName')) {
                    document.getElementById('skillName').focus();
                }
            });
        } else if (activity === types.SUPERADMIN_SKILL_DELETE_SUCCESS) {
            if (numRows === 1 && totalPage > 1) {
                let page = this.state.activePage - 1;
                this.props.skillListAction({ pageSize: this.state.perPageCount, page: page, column: this.state.sortOrder + this.state.sortField });
            } else {
                this.props.skillListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + this.state.sortField });
            }
            this.setToasterState(true, MSG_SKILL_DELETE_SUCCESS, true);
        } else if (activity === types.SUPERADMIN_SKILL_DELETE_ERROR) {
            let errMsg = errorData.message ? errorData.message : JSON.stringify(errorData);
            this.setToasterState(true, errMsg, false);
        }
    }

    componentDidUpdate(prevProps) {
        const { skill, status, activity, numRows, totalPage, errorData, subSectorObj } = this.props;
        if (activity !== prevProps.activity) {
            if (activity === types.SUPERADMIN_SUBSECTOR_LIST_SUCCESS) {
                let newSSObj = [];
                if (subSectorObj && subSectorObj.length) {
                    subSectorObj.forEach(ssObj => {
                        newSSObj.push({ value: ssObj.id, label: ssObj.sector + ' - ' + ssObj.name });
                        //{"id": 148, "sector": "Hospitality", "name": "Caterers"}
                    });
                    this.setState({ subsectorMultiSelList: newSSObj, subSectorsLoaded: true });
                }
            }
            else {
                this.setStateUpdate(skill, status, activity, numRows, totalPage, errorData);
            }
            this.props.clearAction();
        }
    }

    componentDidMount() {
        this.props.subSectorListAction();
        document.title = LBL_APP_NAME + " - " + LBL_SETTINGS + " - " + LBL_SKILLS;
        setTimeout(() => {
            this.props.skillListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + this.state.sortField });
        }, 250)
    }

    showInfo (actVal) {
        document.getElementById('div-fa-info').style.display = actVal; 
    }

    faIconString() {
        const myString = '<i class="fa-solid fa-video"></i>';
        return (
          <div dangerouslySetInnerHTML={{ __html: myString }} /> 
        );
      }

    render() {

        const {
            activePage, startIndex, endIndex, toastMessage, toastFlag, toastSuccess, skillData
        } = this.state

        const { skills, totalPage, status } = this.props;

        if (status === 401 || status === 403) {
            return <Redirect to={ROUTE_REFRESH} />;
        }


        return (

            <div className="col-md-12">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="box-head">
                        <div className='divFloatLeft padding-left-20 padding-top-5 font-14'><Link to={ROUTE_SA_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link> </div>
                        <div className="to-right">
                            <button className="btn btn-primary launch-modal" onClick={this.openModal}>{LBL_BTN_ADDNEW}</button>
                        </div>
                    </div>
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table" className="table" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>{LBL_SKILL}</th>
                                        <th>{LBL_CERTIFICATE_NAME}</th>
                                        <th className="text-center">{LBL_CERTIFICATEMANDATORY}</th>
                                        <th className="text-center">{LBL_SHOW_DATE_RANGE}</th>
                                        <th>{LBL_SUB_SECTORS}</th>
                                        <th>{LBL_ACTIVE}</th>
                                        <th className="text-center">{LBL_ACTIONS}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(this.props.count === 0) &&

                                        <tr>
                                            <td colSpan="8" className="text-center">{MSG_NOT_FOUND}</td>
                                        </tr>
                                    }
                                    {skills.map((item, index) => {
                                        let ssNames = this.getSubSectorNames(item.sub_sectors);
                                        return (
                                            <tr key={item.id}>
                                                <td>{(PAGENUMROWS_SUPER * (activePage - 1)) + index + 1}</td>
                                                <td >
                                                    {item.icon_fontawesome_class && item.icon_fontawesome_class.trim().length > 0 && <><i className={'marginRight10 fas '+item.icon_fontawesome_class}></i> </> }  
                                                    {item.skill_name}</td>
                                                <td >{item.certificate_name}</td>
                                                <td className="text-center">{item.certificate_required ? 'Y' : 'N'}</td>
                                                <td className="text-center">{item.date_range ? 'Y' : 'N'}</td>
                                                <td >{ReactHtmlParser(ssNames)}</td>
                                                <td className="text-center">{item.is_active ? 'Y' : 'N'}</td>
                                                <td className="text-center">
                                                    {item.is_active && <div className="dropdown" id={'dropdown-' + item.id}>
                                                        <button className="dropdown-toggle" type="button"
                                                            id={'dropdownMenuButton-' + item.id} data-toggle="dropdown"
                                                            aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                        >
                                                            <input type="image" id={"img-action-" + item.id} src={require('../../../' + URL_IMG + 'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                        </button>
                                                        <div className="dropdown-menu marginLeft17" id={'dropdown-menu-' + item.id}
                                                            aria-labelledby={'dropdownMenuButton-' + item.id}>
                                                            <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item.id)}>{LBL_EDIT}</Link>  
                                                            <Link className="dropdown-item delete"
                                                                to="#" onMouseDown={(e) => this.deleteBtnClick(item.id, item.skill_name)}>{LBL_DELETE}</Link>
                                                        </div>
                                                    </div>}
                                                </td>
                                            </tr>
                                        )
                                    })
                                    }
                                </tbody>
                            </table>

                            <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext} />
                            <div className="clear-b-scroll-settings">&nbsp;</div>
                            <div className="clear-b-scroll-settings">&nbsp;</div>
                            <div className="clear-b-scroll-settings">&nbsp;</div>
                        </div>
                    </div>
                </div>

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {"Are you sure you want to delete skill '" + this.state.skillNameSelected + "'?"}
                </ModalWindow>


                <ModalWindow ref={this.modalAdd} header={Number(this.state.skillData.skillId) > 0 ? "Edit Skill" : "Add Skill"} saveFormData={(e) => this.onSaveFormData(skillData.skillId)} resetModalForm={this.onModalFormReset} type="save" autoFocusField='skillName'>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_SKILL}</label>
                                <div className="text-input"><input className={this.state.formErrors.skillName.length > 0 ? "input-error" : ''} name="skillName" id="skillName" type="text" placeholder="" value={skillData.skillName || ''} onChange={this.onHandleChange} maxLength={120} /></div>
                                {this.state.formErrors.skillName.length > 0 && this.state.formErrors.skillName != MSG_REQUIRED && (
                                    <div className="text-red left-align text-12">{this.state.formErrors.skillName}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_SUB_SECTOR}</label>
                                <div className="form-group multisel_textbox">
                                    <div className="form-group select-input skills" >
                                        <CustomMultiSelect id={'subSector'} data={this.state.subsectorMultiSelList} trimString='yes' onChange={selected => this.handleChangeMultiSel(selected)} isTextBox={false} marginTop0='marginTop0' classValue={this.state.formErrors.subsectors_error.length > 0 ? "input-error" : ''} listClassName={"div-scroll-y"} />
                                    </div>
                                    {/*  needSelectAll="yes" inputProps={{ tabIndex:"10" }} tabIndex="10" */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="">&nbsp;</label>
                                <div className="checkbox-wrapper">
                                    <div className="custom-checkbox"><input name="certificateRequired" type="checkbox" id="check2" checked={skillData.certificateRequired} onChange={this.onHandleChange} /><label className="checkbox" htmlFor="check2"></label><label className="labeltext" htmlFor="check2">{LBL_CERTIFICATEMANDATORY}</label></div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_CERTIFICATE_NAME}</label>
                                <div className="text-input"><input className={this.state.formErrors.certificateName.length > 0 ? "input-error" : ''} name="certificateName" type="text" placeholder="" value={skillData.certificateName || ''} onChange={this.onHandleChange} maxLength={120} /></div>
                                {this.state.formErrors.certificateName.length > 0 && this.state.formErrors.certificateName != MSG_REQUIRED && (
                                    <div className="text-red left-align text-12">{this.state.formErrors.certificateName}</div>
                                )}
                            </div>
                        </div>
                    </div>
                    {skillData.certificateRequired &&
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <div className="checkbox-wrapper">
                                        <div className="custom-checkbox">
                                            <input name="showDateRange" type="checkbox" id="showDateRange" checked={skillData.showDateRange ? true : false} onChange={this.onHandleChange} />
                                            <label className="checkbox" htmlFor="showDateRange"></label>
                                            <label className="labeltext" htmlFor="showDateRange">{LBL_SHOW_DATE_RANGE}</label>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="">&nbsp;</label>
                                <div className="checkbox-wrapper">
                                    <div className="custom-checkbox">
                                        <input type="checkbox" name="isActive" id="isActive" checked={skillData.isActive ? true : false} onChange={this.onHandleChange} />
                                        <label className="checkbox" htmlFor="isActive"></label>
                                        <label className="labeltext" htmlFor="isActive">{LBL_ACTIVE}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6" style={{position: "relative"}}>
                        
                            <div className="form-group info-text">
                                <div className="div-fa-info"> 
                                    <ul>
                                        <li>{LBL_FONTAWESOME_ICON_GUIDELINE1} <Link to={{ pathname: `${LBL_FONTAWESOME_ICON_URL}`}}  target="_blank">{LBL_FONTAWESOME_ICON_URL}</Link></li>
                                        <li>{LBL_FONTAWESOME_ICON_GUIDELINE2}</li>
                                        <li>{LBL_FONTAWESOME_ICON_GUIDELINE3}</li>
                                        <li>{LBL_FONTAWESOME_ICON_GUIDELINE4}</li>
                                    </ul>         
                                    {LBL_FONTAWESOME_ICON_GUIDELINE5} <input name="txt_faicontext" type="text" placeholder="" value={LBL_FONTAWESOME_ICON_CLASS} style={{border: 'none', width: '250px', fontSize: "1.0rem", marginRight: "-3px"}} /> <br/>
                                    {LBL_FONTAWESOME_ICON_GUIDELINE6} <br/>
                                    <div style={{paddingTop: "10px"}}>
                                    <label className="">{LBL_ICON_FONTAWESOME_CLASS} </label>
                                    <input name="txt_faicontext2" type="text" placeholder="" value={'fa-solid fa-video'} readOnly />
                                    </div>
                                </div>
                                <label className="">{LBL_ICON_FONTAWESOME_CLASS} <i class="margin-left-10 fas fa-solid fa-info"></i></label>
                                <div className="text-input"><input name="iconFontawesomeClass" type="text" placeholder="" value={skillData.iconFontawesomeClass || ''} onChange={this.onHandleChange} maxLength={120} /></div>

                                
                            </div>

                            
                        </div>
                    </div>
                </ModalWindow>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        skills: state.skills.items,
        totalPage: state.skills.totalPage,
        skill: state.skills.item,
        status: state.skills.status,
        activity: state.skills.activity,
        numRows: state.skills.numRows,
        count: state.skills.count,
        errorData: state.skills.errorData,
        subSectorObj: state.skills.subSectorObj,
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        skillListAction: skillListAction,
        subSectorListAction: subSectorListAction,
        skillAddAction: data => skillAddAction(data),
        skillEditAction: id => skillEditAction(id),
        skillUpdateAction: data => skillUpdateAction(data),
        skillDeleteAction: id => skillDeleteAction(id),
        clearAction: clearAction
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(SkillsComponent);